import React from 'react';
import '../styling/PrivacyPage.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> 2025-03-28</p>
      
      <h2>1. Introduction</h2>
      <p>
        Welcome to the Kyro Game Studios website ("Site"). This Privacy Policy explains how Kyro Studios ("we", "us", or "our") collects, uses, and discloses information about you when you visit our Site and use our services, including downloading our games. By using our Site, you agree to the collection and use of information in accordance with this policy.
      </p>
      
      <h2>2. Information We Collect</h2>
      <p>
        We may collect several types of information for various purposes to provide and improve our service to you:
      </p>
      <ul>
        <li>
          <strong>Personal Information:</strong> While using our Site, we may ask you to provide certain personally identifiable information that can be used to contact or identify you. This may include, but is not limited to, your name, email address, and other contact information.
        </li>
        <li>
          <strong>Usage Data:</strong> We may also collect information on how the Site is accessed and used. This Usage Data may include information such as your computer's Internet Protocol address (e.g., IP address), browser type, browser version, the pages of our Site that you visit, and other diagnostic data.
        </li>
        <li>
          <strong>Cookies and Tracking Technologies:</strong> We use cookies and similar tracking technologies to track activity on our Site and hold certain information.
        </li>
      </ul>
      
      <h2>3. How We Use Your Information</h2>
      <p>
        We use the collected data for various purposes:
      </p>
      <ul>
        <li>To provide, maintain, and improve our Site and services.</li>
        <li>To notify you about changes to our Site or services.</li>
        <li>To provide customer support and respond to your inquiries.</li>
        <li>To monitor usage of our Site and analyze trends.</li>
        <li>To detect, prevent, and address technical issues and security breaches.</li>
      </ul>
      
      <h2>4. Cookies and Tracking Technologies</h2>
      <p>
        Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. We use cookies to improve your experience on our Site by remembering your preferences and analyzing site usage. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
      </p>
      
      <h2>5. Disclosure of Your Information</h2>
      <p>
        We may share your information in the following situations:
      </p>
      <ul>
        <li>
          <strong>With Service Providers:</strong> We may share your information with third-party vendors, service providers, and contractors to perform functions on our behalf, such as hosting, data analysis, and customer support.
        </li>
        <li>
          <strong>For Legal Reasons:</strong> We may disclose your information if required to do so by law or in response to valid requests by public authorities (e.g., a court or a government agency).
        </li>
        <li>
          <strong>Business Transfers:</strong> In connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
        </li>
      </ul>
      
      <h2>6. Security</h2>
      <p>
        The security of your data is important to us. While we strive to use commercially acceptable means to protect your Personal Information, no method of transmission over the Internet or method of electronic storage is 100% secure.
      </p>
      
      <h2>7. Links to Other Sites</h2>
      <p>
        Our Site may contain links to other sites that are not operated by us. If you click on a third-party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
      </p>
      
      <h2>8. Children's Privacy</h2>
      <p>
        Our Site is not intended for use by children under the age of 13. We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you are aware that your child has provided us with Personal Information, please contact us.
      </p>
      
      <h2>9. Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page with an updated "Effective Date." You are advised to review this Privacy Policy periodically for any changes.
      </p>
      
      <h2>10. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us:
      </p>
      <p>
        <strong>Kyro Studios</strong><br />
        <a href="mailto:your-email@example.com">support@kyrogamestudios.com</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
